export const DRIVE_STATUS = {
    unknown: { key: 0, lable: '未知' },
    booked: { key: 1, lable: '已预约' },
    arranged: { key: 2, lable: '已安排' },
    driving: { key: 3, lable: '试驾中' },
    drove: { key: 4, lable: '已试驾' },
    evaluated: { key: 5, lable: '已评价' },
    cancelled: { key: 6, lable: '已取消' }
};

// 国际区号
export const AREA_CODE = [
    { key: 86, lable: '中国大陆' },
    { key: 852, lable: '中国香港' },
    { key: 853, lable: '中国澳门' },
    { key: 886, lable: '中国台湾' }
];

export const AREA_CODE_RULE = {
    86: [
        {
            country_code: '86',
            key: 'format_check',
            rule:
                '^((13[0-9])|(14[14-8])|(15[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9])|(111))\\d{8}|(98762)\\d{6}$'
        },
        { country_code: '86', key: 'length_check', rule: '^(\\d{11})$' },
        {
            country_code: '86',
            key: 'virtual_mobile_check',
            rule: '^1(70|71|62|65|67|4[0-8])\\d{8}$'
        }
    ],
    852: [{ country_code: '852', key: 'length_check', rule: '^(\\d{8})$' }],
    853: [{ country_code: '853', key: 'length_check', rule: '^(\\d{8})$' }],
    886: [{ country_code: '886', key: 'length_check', rule: '^(\\d{10})$' }]
};

// 页面类型
export const PAGE_TYPE = {
    YEARLEADS: 'yearLeads', // 年报
    DRIVER: 'driver', // 试驾
    APPDRIVER: 'appDriver', // app内试驾
    APPFRIEND: 'appFriend', // app内邀请好友试驾
    APPFRIENDCONFIRM: 'appFriendConfirm', // 好友邀请记录确认试驾
    APPDRIVERORDER: 'appDriverOrder', // app内我的试驾单
    FRIEND: 'friend', // 好友试驾,
    DEFAULT: 'default' // 默认
};
export const pageTypes = Object.values(PAGE_TYPE);

export const DMP_PAGE_COMPONENT_MAP = {
    text: '文本',
    swiper: '轮播图',
    image: '图片',
    link: '跳转按钮',
    form: '表单',
    form_float: '悬浮组件',
    form_quick: '一键预约',
    fellow: 'Fellow信息',
    task: '任务组件',
    award: '打卡领奖',
    video: '视频组件',
    leads_award: '留资打卡组件',
    corp_authentication: '认证组件'
};

export const DMP_COMPONENT_IS_CLICKABLE = {
    text: false,
    swiper: false,
    image: true,
    link: true,
    form: true,
    form_float: true,
    form_quick: true,
    fellow: true,
    task: true,
    award: true,
    video: false,
    corp_authentication: true
};

export const PAGE_MODE_MAP = {
    drive: '试驾页',
    leads: '留资页',
    other: '其他'
};

export const DMP_LINK_TARGET_TYPE = {
    mp: 'mp',
    h5: 'h5',
    app: 'app'
};

export const DMP_LINK_TARGET_SUBTYPE = {
    configcar: 1, // 配置爱车
    discover: 2, // 逛一逛社区
    appstore: 3, // 下载app
    custom: 4 // 自定义
};

export const WELFARE_PARTICIPATE_STATUS = {
    success: '0001', // 参与成功
    outdate: '0002', // 活动过期
    duplicated: '0003', // 重复参与
    exception: '0004' // 异常情况
};

export const DOWNLOAD_APP_URL =
    'https://a.app.qq.com/o/simple.jsp?pkgname=cn.com.weilaihui3';

export const NIO_SCHEMA = {
    MY_CREDIT: 'nio://my/credit', // 我的积分
    MY_CARD: 'nio://coupon/list', // 我的卡包
    LOGIN: 'nio://user/login', // 登录
    JOIN_CHAT_GROUP: 'nio://chat/group/invite' // 邀请加群 拼 ?group_id=群聊id&inviter_id=邀请人account_id
};

export const INVITATION_CHANNEL_CODE = {
    atPage: 'AT_DRIVE_INVITATION', // AT试驾页面用
    helpTD: 'HELP_INVITE_TD', //帮好友预约试驾
    landingPage: 'INVITATION_LANDINGPAGE', // 邀请专用试驾留资落地页用
    page: 'INVITATION_PAGE', // 其它试驾留资页面用
    sideCode: 'LOCAL_QRCODE'
};

// 新车发布 - 开关未开放前展示敬请期待
export const NEW_CAR_SERIES_LIST = [];



// WEBPACK FOOTER //
// ./src/config/enums.js